"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _StandAloneLayout = _interopRequireDefault(require("./StandAloneLayout/StandAloneLayout"));
var _StandaloneKYCContainer = _interopRequireDefault(require("../components/StandaloneKYC/StandaloneKYCContainer"));
var _withAuthentication = _interopRequireDefault(require("../hocs/withAuthentication"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StandAloneKyc = function StandAloneKyc(_ref) {
  var FormComponent = _ref.FormComponent;
  return /*#__PURE__*/_react["default"].createElement(_StandAloneLayout["default"], null, /*#__PURE__*/_react["default"].createElement(_StandaloneKYCContainer["default"], {
    FormComponent: FormComponent
  }));
};
var _default = exports["default"] = (0, _withAuthentication["default"])(StandAloneKyc);